const brHausefulUsers = {
  hausefulUsers: {
    label: {
      name: 'Nome',
      email: 'E-mail',
      document: 'CPF',
      userType: 'Tipo de usuário',
      rg: 'RG',
      phone: 'Celular',
      birthDate: 'Data Nasc.',
      password: 'Senha',
      repeatPassword: 'Repita a senha',
      isUserTester: 'Usuário teste?',
      isActive: 'Ativo',
      active: 'Ativo',
      deletedAt: 'Removido em {date}',
      services: 'Serviços',
      city: 'Cidade',
      type: 'Tipo',
      yes: 'Sim',
      no: 'Não',
      realEstate: 'Imobiliária',
      branch: 'Filial',
      integration: 'Integração',
      status: 'Status',
      location: 'Localização',
      information: 'Informações',
      activeServices: 'Serviços ativos',
    },

    action: {
      save: 'Salvar usuário',
      edit: 'Atualizar usuário',
      cancel: 'Cancelar',
      create: 'Criar usuário',
      createRealEstate: 'Criar imobiliária',
      delete: 'Remover usuário',
      loading: 'Carregando',
      details: 'Detalhes',
      checklistLink: 'Vincular com app Checklist',
    },

    hints: {
      delete: 'Deseja mesmo remover este usuário?',
    },

    messages: {
      successfullyCreated: 'Usuário criado com sucesso',
      successfullyEdited: 'Usuário editado com sucesso',
      successfullyDeleted: 'Usuário removido com sucesso',
      noServiceTypesSelected: 'Nenhum tipo de serviço selecionado',
      selectServiceTypes: 'Selecione os tipos de serviço',
      noActiveServiceTypes: 'Nenhum tipo de serviço ativo',
      allServiceTypesSelected: 'Todos os tipos de serviço selecionados',
    },
  },
}

export default brHausefulUsers
